import React from "react";
import { Helmet } from "react-helmet";
import LiveStreamsLandingSection from "../../templates/LiveStreamsLandingSection/LiveStreamsLandingSection";
import AllStreamsSection from "../../templates/AllStreamsSection/AllStreamsSection";

const LiveStreams = () => {
    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        "name": "Live Streams",
        "url": "https://churchcamlive.ie/live-streams",
        "description": "Browse live streams of church services, funerals, and other events provided by ChurchCamLive.",
        "publisher": {
            "@type": "Organization",
            "name": "ChurchCamLive",
            "url": "https://churchcamlive.ie"
        }
    };

    return (
        <>
            <Helmet>
                <title>Live Streams</title>
                <meta
                    name="description"
                    content="ChurchCamLive.ie provides live streaming services, audio installation, and network infrastructure solutions to churches, cathedrals, parish homes, and funeral homes."
                />
                <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
            </Helmet>
            <LiveStreamsLandingSection />
            <AllStreamsSection />
        </>
    );
};

export default LiveStreams;
